import Vue from 'vue'

export default class StringVueCompiler {
    static compile (template, components = {}) {
        const compiled = Vue.compile(template)

        const component = new Vue({
            render: compiled.render,
            staticRenderFns: compiled.staticRenderFns,
            components
        })

        component.$mount()

        const compiledTemplate = component.$el.outerHTML

        component.$destroy()

        return compiledTemplate
    }
}